<template>
    <v-card
            class="mx-auto"
            max-width="300"
            flat transparent
            :loading="loading"
    >
        <v-list-item three-line>
            <v-list-item-content>
                <v-list-item-title>
                    <v-chip center
                            :class="getStatusColor(shipment.status)">
                        {{ getShipmentStatusLabel(shipment.status) }}
                    </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle center>
                    {{shipment.tracking_number}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <template v-if="shipment.international_shipping" >
            <v-row class="ml0 mr0">
                <v-col>
            <span class="red--text text-darken-2">Envoi International (hors UE) : il est nécessaire d’imprimer cette facture, à ajouter dans une pochette plastique transparente pour les formalités douanières.</span>
                </v-col>
            </v-row>


            <v-row class="ml0 mr0">
                <v-col>
            <v-btn text color="red darken-2"
                   link
                   target="_blank"
                   :href=shipment.invoice_url
            >
                <v-icon left small >mdi-receipt</v-icon>Facture
            </v-btn>
            <v-btn v-if="shipment.customs_declaration_url"
                   text color="red darken-2"
                   link
                   target="_blank"
                   :href=shipment.customs_declaration_url
            >
                <v-icon left small >mdi-file-document</v-icon>Docs
            </v-btn></v-col>
            </v-row>
        </template>

        <v-card-actions>
            <template v-if="shipment.provider_reference === null">
                <v-row class="ml0 mr0">
                    <v-col>
                        <span class="red--text text-darken-2"><v-icon color="red darken-2" left small >mdi-alert</v-icon>Création du colis impossible. Contactez-nous.</span>
                    </v-col>
                </v-row>            </template>
            <template v-else-if="shipment.status === 'AWAITING_LABEL_GENERATION'">
                <v-btn small block color="indigo lighten-2"
                       @click="createLabel(shipment.id)"
                >
                    <v-icon left>mdi-package</v-icon>Créer
                </v-btn>
            </template>
            <template v-else>
                <template v-if="shipment.tracking_url">
                    <v-btn icon color="indigo lighten-2"
                           link
                           target="_blank"
                           :href=shipment.tracking_url
                    >
                        <v-icon small >mdi-radar</v-icon>
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn icon color="red"><v-icon small >mdi-alert</v-icon></v-btn>
                </template>
                <template v-if="shipment.label_url">
                    <v-btn icon color="indigo lighten-2"
                           link
                           target="_blank"
                           :href=shipment.label_url
                    >
                        <v-icon small >mdi-truck-delivery</v-icon>
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn icon color="red"><v-icon small >mdi-alert</v-icon></v-btn>
                </template>
                <v-spacer></v-spacer>
                <v-tooltip v-if="shipment.sent_datetime || shipment.delivered_datetime"
                           left content-class="white opacity-100">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs"
                               v-on="on"
                               icon color="indigo lighten-2">
                            <v-icon small >mdi-calendar-clock</v-icon>
                        </v-btn>
                    </template>
                    <v-list-item v-if="shipment.sent_datetime">
                        <v-icon left>mdi-calendar-export</v-icon>{{ shipment.sent_datetime | momentDateSimple}}
                    </v-list-item>
                    <v-list-item v-if="shipment.delivered_datetime">
                        <v-icon left >mdi-calendar-import</v-icon>{{ shipment.delivered_datetime | momentDateSimple}}
                    </v-list-item>
                </v-tooltip>
            </template>
        </v-card-actions>
        <v-snackbar
                v-model="snackbar.visible"
                multi-line
                :color="snackbar.color"
                right
                shaped
                top
        >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                        color="primary"
                        text
                        v-bind="attrs"
                        @click="snackbar.visible = false"
                >
                    Fermer
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
    import mappingStatusColors from '../../config/mapping-status-colors.json'

    export default {
        name: 'ShipmentListDetail.vue',
        props: ['shipment'],
        data() {
            return {
                loading: false,
                snackbar: {
                    visible: false,
                    color: '',
                }
            }
        },
        methods:{
            getShipmentStatusLabel(status) {
                return this.$i18n.t('shipments.status_labels.' + status.toLowerCase())
            },
            getStatusColor(status) {
                return mappingStatusColors[status];
            },
            createLabel(shipmentId) {
                this.loading = true;
                this.$axios.post('shipments/' + shipmentId + '/labels', {})
                    .then(() => {
                        this.snackbar.visible = true;
                        this.snackbar.text = this.$i18n.t('product.product_deleted');
                        this.snackbar.color = 'success';
                        this.$emit('onShipmentUpdated');
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.snackbar.visible = true;
                        this.snackbar.color = 'error';
                        if (error && error.response) {
                            this.snackbar.text = this.$i18n.t(error.response.data['hydra:description']);
                        } else {
                            this.snackbar.text = this.$i18n.t('product.product_delete_failed');
                        }
                        this.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>
</style>
